// @ts-ignore
/* eslint-disable */
import { request } from '@umijs/max';
import { objData } from './httpRequest';

// 获取验证码
export async function getCode(options?: { [key: string]: any }) {
  return request<''>('/api/common/getCode', {
    method: 'POST',
    data: objData({}),
    ...(options || {}),
  });
}


/** 获取当前的用户 GET /api/currentUser */
export async function currentUser(body: API.CurrentUser, options?: { [key: string]: any }) {
  // 直接返回mock数据，无论成功与否
  return request<API.CommonResponse>('/api/user/currentUserInfo', {
    method: 'POST',
    data: objData(body),
    ...(options || {}),
  });
}

/** 退出登录接口 POST /api/login/outLogin */
export async function outLogin(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/user/logout', {
    method: 'POST',
    data: objData(body),
    ...(options || {}),
  });
}

/** 登录接口 POST /api/login/account */
export async function login(body: API.LoginParams, options?: { [key: string]: any }) {
  return request<API.LoginResult>('/api/user/login', {
    method: 'POST',
    data: objData(body),
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>('/api/notices', {
    method: 'GET',
    ...(options || {}),
  });
}

/** 获取规则列表 GET /api/rule */
export async function rule(
  params: {
    // query
    /** 当前的页码 */
    current?: number;
    /** 页面的容量 */
    page_size?: number;
  },
  options?: { [key: string]: any },
) {
  return request<API.RuleList>('/api/rule', {
    method: 'GET',
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 更新规则 PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'update',
      ...(options || {}),
    },
  });
}

/** 新建规则 POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>('/api/rule', {
    method: 'POST',
    data: {
      method: 'post',
      ...(options || {}),
    },
  });
}

/** 删除规则 DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>('/api/rule', {
    method: 'POST',
    data: {
      method: 'delete',
      ...(options || {}),
    },
  });
}

/** 获取当前用户的权限 GET /api/role/GetCacheUserPermission */
export async function getCacheUserPermission(body: API.CommonResponse, options?: { [key: string]: any }) {
  return request<API.CommonResponse>('/api/role/GetCacheUserPermission', {
    method: 'POST',
    data: objData(body),
    ...(options || {}),
  });
}
/** 欢迎页 GET /api/common/welcome */
export async function welcome(options?: { [key: string]: any }) {
  return request<API.CommonResponse>('/api/common/welcome', {
    method: 'POST',
    ...(options || {}),
  });
}
